import { render } from "./cutter.vue?vue&type=template&id=588722bf&scoped=true"
import script from "./cutter.vue?vue&type=script&lang=js"
export * from "./cutter.vue?vue&type=script&lang=js"

import "./cutter.vue?vue&type=style&index=0&id=588722bf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\67026\\Desktop\\front1.0\\front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588722bf"]])

export default __exports__